import { BillingBody, BillingView } from '@lemoncloud/lemon-billings-api';

import { ListResult, Params } from '@codes/base-api';
import { webCore } from '@codes/web-core';

import { UpdateBillingDTO } from '../types';

const BILLING_BACKEND = import.meta.env.VITE_BILLING_ENDPOINT.toLowerCase();

export const createBilling = async (body: BillingBody): Promise<BillingView> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BILLING_BACKEND}/billings/0/order`,
        })
        .setBody(body)
        .execute<BillingView>();

    return data;
};

export const createBulkBillings = async (body: BillingBody[]): Promise<ListResult<BillingView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BILLING_BACKEND}/billings/0/bulk-order`,
        })
        .setBody({ list: body })
        .execute<ListResult<BillingView>>();

    return data;
};

export const fetchBillings = async (params: Params): Promise<ListResult<BillingView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BILLING_BACKEND}/billings/0/list`,
        })
        .setParams({ ...params })
        .execute<ListResult<BillingView>>();

    return { ...data };
};

export const fetchBillingById = async (billingId?: string): Promise<BillingView> => {
    if (!billingId) {
        throw new Error('fetchBillingById: @billingId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BILLING_BACKEND}/billings/${billingId}/detail`,
        })
        .execute<BillingView>();

    return { ...data };
};

export const updateBilling = async (updateBody: UpdateBillingDTO): Promise<BillingView> => {
    const { billingId, ...data } = updateBody;
    if (!billingId) {
        throw new Error('updateBilling: @billingId is required');
    }

    const response = await webCore
        .buildSignedRequest({
            method: 'PUT',
            baseURL: `${BILLING_BACKEND}/billings/${billingId}`,
        })
        .setBody({ ...data })
        .execute<BillingView>();

    return response.data;
};

export const deleteBilling = async (billingId: string): Promise<BillingView> => {
    if (!billingId) {
        throw new Error('deleteBilling: @billingId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'DELETE',
            baseURL: `${BILLING_BACKEND}/billings/${billingId}`,
        })
        .setBody({})
        .execute<BillingView>();

    return data;
};
